import * as React from 'react';
import { createFileRoute, redirect } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { z } from 'zod';
import { FormatGroupsListPage } from '../../../features/admin/format-groups/components/format-groups-list-page';
import { SYSTEM_ROLE_CODE } from '../../../features/permissions/lib/role-codes';
import { PageTitleContext } from '../../__root';

// ─── Search params schema ─────────────────────────────────────

const FormatGroupsSearchSchema = z.object({
  isActive: z.boolean().optional().catch(undefined),
});

// ─── Route ───────────────────────────────────────────────────

export const Route = createFileRoute('/admin/dictionaries/format-groups')({
  validateSearch: FormatGroupsSearchSchema,
  beforeLoad: ({ context }) => {
    const user = context.auth.user;
    if (!user) {
      throw redirect({ to: '/login' });
    }
    if (!user.roles.includes(SYSTEM_ROLE_CODE)) {
      throw redirect({ to: '/media-units' });
    }
  },
  component: FormatGroupsRoute,
});

function FormatGroupsRoute() {
  const { setPageTitle } = React.useContext(PageTitleContext);
  const { t } = useTranslation('admin');

  React.useEffect(() => {
    setPageTitle(t('formatGroups.pageTitle'));
  }, [setPageTitle, t]);

  return <FormatGroupsListPage />;
}
